// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2fF5Y","wrapper":"styles_wrapper__1v17j","right":"styles_right__1Q1lT","link":"styles_link__2J0bP","pic":"styles_pic__8upz9"};